import { composeSchema, createMarkdownRteEditor, createTextEditor } from '@refract-cms/core';
import Icon from '@material-ui/icons/Message';

export const ContactSchema = composeSchema({
  options: {
    alias: 'contact',
    displayName: 'Contact',
    icon: Icon,
    maxOne: true,
    mongoCollectionName: 'contact',
  },
  properties: {
    contactText: {
      type: String,
      displayName: 'Contact text',
      editorComponent: createMarkdownRteEditor(),
    },
    address: {
      type: String,
      displayName: 'Address',
      editorComponent: createTextEditor({ multiline: true }),
    },
  },
});
